export const primaryColor = "#0B2B4C";
export const secondaryColor = "#F37B2C";
export const ternaryColor = "#6D849C";
export const lightPrimaryColor = "#75ACE4;";

export enum RedirectLink {
  HOME = "/",
  AboutUs = "/about-us",
  Services = "/services",
  ContactUs = "/contact-us",
  EMICalculator = "/emi-calculator",
  OurPolices = "/our-policies",
  Payments = "/payments",
}

export const links = [
  { title: "Home", link: RedirectLink.HOME },
  { title: "About Us", link: RedirectLink.AboutUs },
  { title: "Services", link: RedirectLink.Services },
  { title: "Contact Us", link: RedirectLink.ContactUs },
  { title: "Our Policies", link: RedirectLink.OurPolices },
  { title: "Payments", link: RedirectLink.Payments },
  { title: "EMI Calculator", link: RedirectLink.EMICalculator },
];

export enum PageTitle {
  HOME = "Tresor Micro | Home",
  AboutUs = "Tresor Micro | About Us",
  Services = "Tresor Micro | Services",
  EMICalculator = "Tresor Micro | Emi Calculator",
  OurPolices = "Tresor Micro | Our Policies",
}

export enum ServicesSectionId {
  GoldLoan = "gold-loan",
  BusinessLoan = "business-loan",
  PersonalLoan = "personal-loan",
  GroupLoan = "group-loan",
}
